module.exports = __webpack_public_path__ + "img/actimg.24bd05a2.png";